import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { WebSimuladorAreaAberta } from 'src/models/WebSimuladorAberta.model';

@Injectable({
  providedIn: 'root'
})
export class WebSimulacaoService {

  private strAction = 'api/WebSimulacao';

  constructor(private http: HttpClient) { }

  EmailSimulacao(WebSimulacao : WebSimuladorAreaAberta) {
    return this.http.post<WebSimuladorAreaAberta>(`${environment.apiAdm}${this.strAction}/EmailSimulacao` , WebSimulacao)
  }

}
